<template>
  <div class="p_resource_module">
    <div class="topOperation">
        <div class="top-left">
            <ShowNavHead />
            <div class="screenInputs">
              <div class="screenInput">
                    <div class="flname">所属项目</div>
                    <el-select
                        v-model="listQuery.strProjectName" filterable clearable
                        size="small" placeholder=""
                      >
                      <el-option
                        v-for="(item, index) in projectList"
                        :key="index"
                        :label="item.StrprojectName"
                        :value="item.StrprojectName">
                      </el-option>
                    </el-select>
                </div>
                <div class="screenInput">
                    <div class="flname">姓名</div>
                    <el-input v-model="listQuery.strUserName" size="small" clearable @keyup.enter.native="searchHandle"></el-input>
                </div>
                <div class="screenInput">
                    <div class="flname">联系方式</div>
                    <el-input v-model="listQuery.strMobile" size="small" clearable @keyup.enter.native="searchHandle"></el-input>
                </div>
                <div class="screenInput">
                    <el-tooltip class="scr_icon" effect="dark" content="高级检索项" placement="top-start">
                    <i class="i_txt" @click="dropDownScreen">更多<i class="el-icon-caret-bottom"></i></i>
                    </el-tooltip>
                </div>
            </div>
        </div>
        <div class="top-right">
            <el-button v-if="showDropScreen==-1" :disabled="isSearchHandle" type="success" size="small" @click="searchHandle" style="margin-right:24px">搜索</el-button>
        </div>
    </div>
    <div class="r_dropDownScreen" v-show="showDropScreen==1">
        <div class="pro_down_box">
            <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="100px">
                <!-- <el-form-item label="自然人ID:">
                    <el-input v-model="listQuery.gdPsnId" size="small" clearable></el-input>
                </el-form-item> -->
                <el-form-item label="身份证:">
                    <el-input v-model="listQuery.strIdCard" size="small" clearable></el-input>
                </el-form-item>
                <el-form-item label="招聘渠道:">
                  <el-select v-model="listQuery.strRecchan" clearable placeholder="" size="small">
                    <el-option value="社招">社招</el-option>
                    <el-option value="公司渠道">公司渠道</el-option>
                    <el-option value="外部渠道">外部渠道</el-option>
                    <el-option value="企业转移">企业转移</el-option>
                    <el-option value="内荐">内荐</el-option>
                    <el-option value="独立招聘">独立招聘</el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="是否约面:">
                    <el-select v-model="listQuery.strIsappo" clearable placeholder="" size="small">
                        <el-option value="已约面">已约面</el-option>
                        <el-option value="未约面">未约面</el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="是否到面:">
                    <el-select v-model="listQuery.strIsface" clearable placeholder="" size="small">
                        <el-option value="已到面">已到面</el-option>
                        <el-option value="未到面">未到面</el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="是否通过:">
                    <el-select v-model="listQuery.strIsadopt" clearable placeholder="" size="small">
                        <el-option value="已通过">已通过</el-option>
                        <el-option value="未通过">未通过</el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="是否入职:">
                    <el-select v-model="listQuery.strIsInduc" clearable placeholder="" size="small">
                        <el-option value="已入职">已入职</el-option>
                        <el-option value="未入职">未入职</el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="在职状态:">
                    <el-select v-model="listQuery.strWorkState" clearable placeholder="" size="small">
                        <el-option value="在职">在职</el-option>
                        <el-option value="离职">离职</el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="在职时长:">
                    <el-select v-model="listQuery.strinductday" filterable clearable placeholder=""
                    size="small">
                        <el-option
                            v-for="(item, index) in durationList"
                            :key="index"
                            :label="item.Name"
                            :value="item.Name">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="简历创建人:" class="com_space_content">
                    <div class="com_space_box">
                        <el-cascader size="small" placeholder="请选择部门"
                        v-model="perDepartList" :props="props" clearable filterable
                        :options="departList"
                        @change="perSectionChange"></el-cascader>
                        <el-select size="small" placeholder=""
                        v-model="listQuery.stresuuserid" filterable clearable>
                            <el-option v-for="(item, index) in memberSearchList"
                            :key="index"
                            :label="item.Username"
                            :value="item.Userid">
                            </el-option>
                        </el-select>
                    </div>
                </el-form-item>
                <el-form-item label="约面人:" class="com_space_content">
                    <div class="com_space_box">
                        <el-cascader size="small" placeholder="请选择部门"
                        v-model="perDepartList" :props="props" clearable filterable
                        :options="departList"
                        @change="perSectionChange"></el-cascader>
                        <el-select size="small" placeholder=""
                        v-model="listQuery.strappouserid" filterable clearable>
                            <el-option v-for="(item, index) in memberSearchList"
                            :key="index"
                            :label="item.Username"
                            :value="item.Userid">
                            </el-option>
                        </el-select>
                    </div>
                </el-form-item>
                <el-form-item label="项目客服:" class="com_space_content">
                    <div class="com_space_box">
                        <el-cascader size="small" placeholder="请选择部门"
                        v-model="perDepartList" :props="props" clearable filterable
                        :options="departList"
                        @change="perSectionChange"></el-cascader>
                        <el-select size="small" placeholder=""
                        v-model="listQuery.strUserkf" filterable clearable>
                            <el-option v-for="(item, index) in memberSearchList"
                            :key="index"
                            :label="item.Username"
                            :value="item.Userid">
                            </el-option>
                        </el-select>
                    </div>
                </el-form-item>
                <el-form-item label="岗位:" class="com_space_content">
                    <div class="com_space_box">
                      <el-cascader ref="poSearchArr" size="small" placeholder=""
                      v-model="listQuery.posCategoryList" :props="propPosition" clearable
                      :options="intendedPost"
                      @change="poSearchChange"></el-cascader>
                        <!-- <el-select size="small" placeholder=""
                        v-model="listQuery.strUserkf" filterable clearable>
                            <el-option v-for="(item, index) in memberSearchList"
                            :key="index"
                            :label="item.Username"
                            :value="item.Userid">
                            </el-option>
                        </el-select> -->
                    </div>
                </el-form-item>
                <el-form-item label="约面时间:" class="com_date_content">
                    <div class="com_date_box">
                        <el-date-picker size="small" value-format="yyyy-MM-dd"
                        v-model="listQuery.strappodts"
                        type="date"
                        placeholder="选择日期">
                        </el-date-picker>
                        <span>-</span>
                        <el-date-picker size="small" value-format="yyyy-MM-dd"
                        v-model="listQuery.strappodte"
                        type="date"
                        placeholder="选择日期">
                        </el-date-picker>
                    </div>
                </el-form-item>
                <el-form-item label="面试时间:" class="com_date_content">
                    <div class="com_date_box">
                        <el-date-picker size="small" value-format="yyyy-MM-dd"
                        v-model="listQuery.strfacedts"
                        type="date"
                        placeholder="选择日期">
                        </el-date-picker>
                        <span>-</span>
                        <el-date-picker size="small" value-format="yyyy-MM-dd"
                        v-model="listQuery.strfacedte"
                        type="date"
                        placeholder="选择日期">
                        </el-date-picker>
                    </div>
                </el-form-item>
                <el-form-item label="通过时间:" class="com_date_content">
                    <div class="com_date_box">
                        <el-date-picker size="small" value-format="yyyy-MM-dd"
                        v-model="listQuery.stradoptdts"
                        type="date"
                        placeholder="选择日期">
                        </el-date-picker>
                        <span>-</span>
                        <el-date-picker size="small" value-format="yyyy-MM-dd"
                        v-model="listQuery.stradoptdet"
                        type="date"
                        placeholder="选择日期">
                        </el-date-picker>
                    </div>
                </el-form-item>
                <el-form-item label="入职时间:" class="com_date_content">
                    <div class="com_date_box">
                        <el-date-picker size="small" value-format="yyyy-MM-dd"
                        v-model="listQuery.strInductdts"
                        type="date"
                        placeholder="选择日期">
                        </el-date-picker>
                        <span>-</span>
                        <el-date-picker size="small" value-format="yyyy-MM-dd"
                        v-model="listQuery.strInductdte"
                        type="date"
                        placeholder="选择日期">
                        </el-date-picker>
                    </div>
                </el-form-item>
                <el-form-item label="离职时间:" class="com_date_content">
                    <div class="com_date_box">
                        <el-date-picker size="small" value-format="yyyy-MM-dd"
                        v-model="listQuery.strquitdts"
                        type="date"
                        placeholder="选择日期">
                        </el-date-picker>
                        <span>-</span>
                        <el-date-picker size="small" value-format="yyyy-MM-dd"
                        v-model="listQuery.strquitdte"
                        type="date"
                        placeholder="选择日期">
                        </el-date-picker>
                    </div>
                </el-form-item>
                <el-form-item label="简历创建时间:" class="com_date_content">
                    <div class="com_date_box">
                        <el-date-picker size="small" value-format="yyyy-MM-dd"
                        v-model="listQuery.strdtinsrtdts"
                        type="date"
                        placeholder="选择日期">
                        </el-date-picker>
                        <span>-</span>
                        <el-date-picker size="small" value-format="yyyy-MM-dd"
                        v-model="listQuery.strdtinsrtdte"
                        type="date"
                        placeholder="选择日期">
                        </el-date-picker>
                    </div>
                </el-form-item>
            </el-form>
        </div>
        <div class="drop-footer">
            <el-button size="small" plain @click="resetHandle()">清空</el-button>
            <el-button size="small" type="info" plain @click="showDropScreen=-1">关闭</el-button>
            <el-button :disabled="isSearchHandle" size="small" type="success" @click="searchHandle()">搜索</el-button>
        </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>雇员</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/signupList' }">面试入职流程</el-breadcrumb-item>
          <el-breadcrumb-item>流程记录</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <ResourceComTabs ref="child" :btnAuth="permissionLists" :active="activeName" @change="currChange($event)"></ResourceComTabs>
        <el-tabs v-model="ststus" @tab-click="handleClick" class="p_tabs_box">
          <el-tab-pane label="流程未入职" name="流程未入职"></el-tab-pane>
          <el-tab-pane label="流程已入职" name="流程已入职"></el-tab-pane>
        </el-tabs>
        <div class="p_btn_box">
            <el-button v-if="checkPermission(['processRecord_allexport'],permissionLists)" size="small" type="success" plain @click="exportHandle" :loading="btnLoading">导出所有明细</el-button>
        </div>
        <el-table v-if="ststus == '流程未入职'" ref="multipleTable" :span-method="objectSpanMethod" border class="re_table" v-loading="tableLoading" @selection-change="handleSelectionChange" :max-height="tableHeight-100" :data="tableData" style="width:100%">
          <template v-for="(item,index) in tableTitle">
            <el-table-column :prop="item.StrColumId" :label="item.StrColumName" fit :show-overflow-tooltip="true" :key="index" :min-width="item.StrColumName.indexOf('性别')>-1||item.StrColumName.indexOf('年龄')>-1||item.StrColumName.indexOf('籍贯')>-1||item.StrColumName.indexOf('学历')>-1 ? '50px' : item.StrColumName.indexOf('项目名称')>-1||item.StrColumName.indexOf('客户名称')>-1||item.StrColumName.indexOf('原因')>-1||item.StrColumName.indexOf('地')>-1||item.StrColumName.indexOf('时间')>-1?'170px':'120px'" align="center"
              :fixed="item.StrColumName=='姓名'||item.StrColumName=='手机号'">
              <template slot-scope="{row}">
                <span v-if="item.StrColumName=='录入时间'">{{ isNull(row[item.StrColumId]) ? '' : row[item.StrColumId].replace('T',' ')}}</span>
                <span v-else>{{ isNull(row[item.StrColumId]) ? '' : row[item.StrColumId]}}</span>
              </template>
            </el-table-column>
          </template>
        </el-table>
         <!-- :highlight-current-row="true" -->
        <el-table v-if="ststus == '流程已入职'" ref="multipleTable" :span-method="objectSpanMethod" border class="re_table" v-loading="tableLoading" @selection-change="handleSelectionChange" :max-height="tableHeight-100" :data="tableData" style="width:100%">
          <template v-for="(item,index) in tableTitle">
            <el-table-column :prop="item.StrColumId" :label="item.StrColumName" fit :show-overflow-tooltip="true" :key="index" :min-width="item.StrColumName.indexOf('性别')>-1||item.StrColumName.indexOf('年龄')>-1||item.StrColumName.indexOf('籍贯')>-1||item.StrColumName.indexOf('学历')>-1 ? '50px' : item.StrColumName.indexOf('项目名称')>-1||item.StrColumName.indexOf('客户名称')>-1||item.StrColumName.indexOf('原因')>-1||item.StrColumName.indexOf('地')>-1||item.StrColumName.indexOf('时间')>-1||item.StrColumName.indexOf('身份证号')>-1?'170px':'120px'" align="center"
              :fixed="item.StrColumName=='身份证号'||item.StrColumName=='姓名'">
              <template slot-scope="{row}">
                <span v-if="item.StrColumName=='录入时间'">{{ isNull(row[item.StrColumId]) ? '' : row[item.StrColumId].replace('T',' ')}}</span>
                <span v-else>{{ isNull(row[item.StrColumId]) ? '' : row[item.StrColumId]}}</span>
              </template>
            </el-table-column>
          </template>
        </el-table>
        <div class="block">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="listQuery.currpage"
            :page-size="listQuery.perpage"
            @size-change="handleSizeChange"
            :page-sizes="[10, 20, 50, 100, 200]"
            layout="total,sizes,prev,pager,next,jumper"
            :total="total"
          ></el-pagination>
      </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
import xz from "./../../common";
import ResourceComTabs from "./components/resourceComTabs.vue"
import checkPermission from '@/utils/permission' // 权限判断函数
export default {
  components: {
    ResourceComTabs
  },
  data() {
    var validatePhone = (rule, value, callback) => {
      const phoneReg = /^(13[0-9]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])\d{8}$/i;
      // console.log('validatePhone',value)
      if (value.length == 11 && phoneReg.test(value)) {
        //校验通过
        this.checkHandle(value, (res) => {
          // console.log('validatePhone',res)
          if (res) {
            this.getResumeDtl(this.enterResumeQuery.ResumeId)
            callback()
          } else {
            callback()
          }
        })
      } else {
        callback(new Error('请输入正确的手机号'))
      }
    }
    return {
      // 是否能点击搜索按钮
      isSearchHandle:false,
      // 项目列表
      projectList:[],
      // 项目名称列表参数
      proNameQuery:{
        searchVal:'',
        pageSize: 100000000,
        pageNum: 1
      },
      // 表头
      tableTitle: [],
      // 表头参数
      titleQuery: {
        strTableId: 'JB_busi_PsnBaseSign',
        strIsFixed: '' // 1 基础 0 扩展 空 所有
      },
      // 意向岗位列表
      intendedPost: [],
      // 部门参数
      departQuery:{
        strorgancode:'',
        roletype:''
      },
      departMemberQuery: {
          keyword: '',
          strWorkState: '在职',
          currpage: 1,
          perpage: 100000
      },
      // 部门列表
      departList:[],
      // 选中的部门
      perDepartList:[],
      // 人员列表
      memberList:[],
      // 自定义 级联选择props
      propPosition: { label: 'strParametername', value: 'strParameterid', children: 'children', checkStrictly: true },
      props: { label: 'strorganname', value: 'strorgancode', children: 'children', checkStrictly: true },
      tableHeight: 0,
      showDropScreen: -1,
      activeName: '流程记录',
      activeCurr:'流程未入职',
      // 获取表头参数
      ststus:'流程未入职',
      tabids: [],
      // 列表参数
      listQuery:{
        currpage:1,
        perpage:10,
        posCategoryList:[],
        strProjectName:'', // 项目名称
        strUserName:'', // 姓名
        strMobile:'', // 联系方式
        strIdCard:'', // 身份证
        gdPsnId:'', // 自然人id
        stresuuserid:'', // 简历录入人
        strdtinsrtdts:'', // 简历录入开始时间
        strdtinsrtdte:'', // 简历录入开始时间
        strWorkState:'', // 在职状态
        strProjectName:'', // 项目名称
        strJobInf:'', // 岗位
        strUserkf:'', // 项目客服
        strRecchan:'', // 招聘渠道
        strIsappo:'', // 是否约面
        strIsface:'', // 是否到面
        strIsadopt:'', // 是否通过
        strIsInduc:'', // 是否入职
        strappouserid:'', // 约面人
        strappodts:'', // 约面时间开始
        strappodte:'', // 约面时间结束
        strfacedts:'', // 到面时间开始
        strfacedte:'', // 到面时间结束
        stradoptdts:'', // 通过时间开始
        stradoptdet:'', // 通过时间结束
        strInductdts:'', // 入职时间开始
        strInductdte:'', // 入职时间结束
        strquitdts:'', // 离职时间开始
        strquitdte:'', // 离职时间结束
        strinductday:'', // 在职时长
        roletype: localStorage.loginRoletype,
        strtype:'' // 区分（必填 流程未入职  流程已入职）
      },
      // 导出参数
      exportQuery:{},
      tableLoading: false,
      tableData: [],
      isCanHandle: true,
      total: 0,
      multipleSelection: [],
      roleType: localStorage.loginRoletype,
      // 省份
      provinces: [],
      propsAddress: {
        lazy: true,
        checkStrictly: true,
        value: 'Id',
        label: 'Name',
        lazyLoad(node, resolve) {
          const { value, level } = node;
          if (value && value != undefined) {
            xz.getArea(value).then(res => {
              if (res.status == 'ok') {
                if (level === 2) {
                  resolve(
                    res.data.ret.map(item => {
                      item.leaf = 'leaf'
                      return item
                    })
                  )
                } else {
                  resolve(res.data.ret)
                }
              } else {
                this.$message.error('获取城市出错')
              }
            })
          }
        }
      },
      btnLoading:false,
      matchCount:0,
      // 招聘来源(来源)列表
      originList:[],
      // 在职时长
      durationList:[],
      // 人员列表
      memberSearchList:[],
      // 客服/顾问参数
      oneDepartQuery:{
        strorgancode:'',
        roletype:''
      },
      depMemberQuery:{
        currpage: 1,
        perpage: 10000,
        strWorkState:'在职',
        keyword:''
      },
      rowspan: [],
      // 按钮权限参数
      butQuery:{
        path:'/signupList',
        powerEnName:'employee'
      },
      permissionLists:[]
    }
  },
  created() {
    // this.proNameQuery.roletype = localStorage.loginRoletype
    // this.proNameQuery.strorgancode = localStorage.gancode
    // this.calHeight()
    // this.getButtonPower()
    // // 获取项目列表
    // this.getProNameList()
    // // 客服列表
    // this.getCusList('customer')
    // // 部门列表
    // this.getDepartList()
    // // 获取省份
    // this.getprovinces(0)
    // // 意向岗位
    // this.getTreestr()
  },
  methods: {
    checkPermission,
    // 获取按钮权限
    getButtonPower(){
      xz.getbtnPowerIdBypage(this.butQuery).then(res => {
        // console.log('按钮',res)
        if(res.status == 'ok'){
          let resmsg = res.msg
          if(!this.isNull(resmsg)){
            for (let index = 0; index < resmsg.length; index++) {
              let element = resmsg[index];
              this.permissionLists.push(element.Enname);
            }
          }else{
            this.permissionLists = []
          }
        }else{
          this.permissionLists = []
        }
      })
    },
    // 子组件传值
    async currChange(value) {
      // console.log('currChange',value)
      this.activeName = value
      this.getTableTitleLists()
    },
    handleClick(tab){
      this.ststus = tab.name
      this.listQuery.currpage = 1
      this.listQuery.perpage = 10
      this.getTableTitleLists()
    },
    //单元格合并
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      // 行，列，行下标，列下标( 控制要合并的列 )
      if ([0].includes(columnIndex)) {
        const _row = this.rowspan[rowIndex];
        const _col = _row > 0 ? 1 : 0; // 如果这一行隐藏了，这列也隐藏
        return {
          rowspan: _row, //合并的行数
          colspan: _col, //合并的列数，设为０则直接不显示
        };
      }
    },
    //参数列表（招聘来源 118）
    getdictdatalistbyid(id) {
      xz.getdictdatalistbyid(id).then(res => {
        // console.log('getdictdatalistbyid', res)
        if (res.status == 'ok') {
          if(id == '118'){
            this.originList = res.data.retList
          }
        }
      })
    },
    // 获取客服/顾问列表
    getCusList(type){
      xz.getUserInfoBytoporgancode(this.oneDepartQuery.strorgancode,this.oneDepartQuery.roletype,this.depMemberQuery).then(res => {
        // console.log('员工', res)
        if (res.status == 'ok') {
          if(type == 'customer'){
            this.memberSearchList = res.msg
          }else{
            // 客服列表
            this.memberSearchList = []
          }
        }
      })
    },
    // 获取项目名称列表
    getProNameList(){
      xz.getplancomrecordprojectlist(this.proNameQuery, localStorage.loginRoletype).then(res => {
        // console.log('项目名称列表', res)
        if (res.status == 'ok') {
          this.projectList = res.data
        } else {
          this.projectList = []
        }
      })
    },
    // 人岗匹配列表
    getMatchList(){
      xz.wxappgetjoblist(this.roleType,this.matchQuery).then(res => {
        // console.log('getMatchList', res)
        if (res.status == 'ok') {
          this.recommendList = res.data.retList
          this.matchCount = res.data.count
        }else{
          this.recommendList = []
          this.matchCount = 0
        }
      })
    },
    // 搜索岗位选择
    poSearchChange(){
      const checkedNode1 =  this.$refs['poSearchArr'].getCheckedNodes();
      let labels = checkedNode1[0].pathLabels;
      if(labels.length > 1){
        this.listQuery.strJobInf = labels[0] + '-' + labels[1];
      }else if(labels.length == 1){
        this.listQuery.strJobInf = labels[0];
      }
    },
    // 验证手机号
    checkHandle(chkval, callback){
      if (chkval.length > 0) {
        xz.checkResumeMobile({strMobile: chkval}).then(res => {
          // console.log('checkHandle', res)
          if (res.status == 'ok') {
            if(Number(res.msg) > 0){
              this.enterResumeQuery.ResumeId = res.msg
              callback(true)
            }else{
              callback(false)
            }
          }
        })
      }
    },
    // 业绩归属部门选择
    perSectionChange(val){
      // console.log('业绩归属部门', val)
      if(this.isNull(val)){
        this.listQuery.strbusdep = ''
      }else{
        this.listQuery.strbusdep = val[Number(val.length)-1]
      }
      // this.departQuery.strorgancode = val[Number(val.length)-1]
      // this.departQuery.roletype = localStorage.loginRoletype
      // this.getMemberList('partner')
    },
    //获取省份
    getprovinces(parent) {
      xz.getArea(parent).then(res => {
        // console.log('getprovinces', res)
        if (res.status == 'ok') {
          this.provinces = res.data.ret;
        } else {
          this.provinces = [];
        }
      })
    },
    // 意向岗位 岗位类别
    getTreestr() {
      let data = {
        currpage: 1,
        perpage: 10000,
        strIsDisable:'', // 传1 禁用的看不到了  不传就全显示
        keyword: ''
      }
      xz.getTreestr('JB_base_Jobcategory', data).then(res => {
        if (res) {
          this.intendedPost = res.msg.parent
        } else {
          this.intendedPost = []
        }
      })
    },
    //筛选下拉
    dropDownScreen() {
      if (this.showDropScreen == -1) {
        this.showDropScreen = 1;
      } else if (this.showDropScreen == 1) {
        this.showDropScreen = -1;
      }
    },
    // 表格多选
    handleSelectionChange(val) {
      // console.log('yyy',val)
      this.noticeData = val
      let resumeIdList = []
      this.multipleSelection = val;
      if(!this.isNull(val)){
        for (let i = 0; i < val.length; i++) {
          const elementval = val[i];
          resumeIdList.push(elementval.ResumeId)
        }
        this.injectQuery.resumeIds = resumeIdList.toString() // 简历id (多条用,连接)
        this.divideQuery.resumeIds = resumeIdList.toString()
      }
    },
    //数组去重
    unique(arr) {
      for (let i = 0; i < arr.length; i++) {
        for(let j = i+1; j < arr.length; j++){
          if(arr[i].toString()==arr[j].toString()){
            arr.splice(j,1);
            j--;
          }
        }
      }
      return arr;
    },
    //分页
    handleCurrentChange(val){
        this.listQuery.currpage = Number(val)
        this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.currpage = 1
      this.listQuery.perpage = Number(val)
      this.getList()
    },
    // 查询字符的数量
    sGetCharCount(str,char) {
      let regex = new RegExp(char, 'g');
      let result = str.match(regex);
      let count=!result ? 0 : result.length;
      return count;
    },
    // 获取列表
    getList(){
      this.tableLoading = true
      this.isSearchHandle = true
      this.listQuery.strtype = this.ststus
      this.tableData = []
      // this.total = 0
      let arr = []; //存放格式后的数据
      let rowspan = []; //存放数组每行的 合并row 数据
      xz.getsignResumeRecordLists(this.listQuery).then(res => {
        // console.log('getList', res)
        if (res.status == 'ok') {
          if(!this.isNull(res.msg)){
            res.msg.forEach((item) => {
              this.$set(item, 'data', item.data)
            })
            this.tableData = res.msg
            this.total = res.totalcount
            let data = this.tableData;
            data.forEach((item) => {
              let { data = [], ...others } = item;
              data = data.map((item, index) => {
                if(index === 0) {
                  rowspan.push(data.length);
                } else {
                  rowspan.push(0);
                }
                return { ...others, ...item };
              });
              arr.push(...data);
            });
            this.tableData = arr; //处理好格式的 arr 进行赋值
            this.rowspan = rowspan;
            // console.log('99',this.tableData,rowspan)
          }
          }else{
            this.tableData = []
            this.total = 0
          }
        this.tableLoading = false
        this.isSearchHandle = false
      })
    },
    // 搜索
    searchHandle(){
      this.listQuery.currpage = 1
      this.listQuery.strJobInf = !this.isNull(this.listQuery.posCategoryList)?this.listQuery.posCategoryList.toString():''
      this.getTableTitleLists()
    },
    // 简历导出
    exportHandle(){
      this.exportQuery = JSON.parse(JSON.stringify(this.listQuery))
      this.exportQuery.perpage = 1000000
      this.exportQuery.currpage = 1
      this.exportQuery.ststus = this.ststus
      // if(this.isNull(this.multipleSelection)){
      //   this.$message({
      //       message: "请选择要导出的数据",
      //       type: "warning"
      //     })
      //     return false
      // }else{
        // console.log('88',this.exportQuery)
        this.btnLoading = true
        // type 0 私有  1公海  2流程(报名)  3流程统计
        xz.outputResumeList('3', this.exportQuery).then(res => {
          if (res.status == 'ok') {
            this.$router.push({
              path: "/resImportList",
              query: {
                showPage: 1,
                isActive: 1,
                custname: res.msg,
                active:'导入导出记录',
                //qStstus=1时查看最后一条导出记录
                qStstus: 1
              }
            })
          } else {
            this.$message({
              message: "导出失败，请稍后再试",
              type: "error"
            })
          }
          this.btnLoading = false
        })
    },
    // 获取部门列表
    getDepartList(){
      xz.getorganstr(this.departQuery.strorgancode,this.departQuery.roletype,{strIsDisable:'1'}).then(res => {
        // console.log('部门', res)
        if (res.status == 'ok') {
            if(res.msg && res.msg.parent){
              this.departList = res.msg.parent[0].children
            }else {
              this.departList = []
            }
        }
      })
    },
    // 获取表头
    getTableTitleLists(){
      xz.getProcessColumnList(this.ststus).then(res => {
        if (res.status == 'ok') {
          this.tableTitle = res.msg
          this.getList()
        }else{
          this.tableTitle = []
        }
        // console.log('getList', this.tableTitle)
      })
    },
    // 清空
    resetHandle(){
      this.listQuery = this.$options.data.call(this).listQuery
    },
    calHeight(){
      this.tableHeight = Number(document.body.clientHeight)
    //   console.log('height',this.tableHeight)
    },
    //判断是否为空(包含0)
    isNull(o) {
      return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN' || o == ('1900-01-01') || o == '1900-01-01T00:00:00';
    }
  }
}
</script>

<style scoped>
.r_dropDownScreen{
  width: 100%;
  box-sizing: border-box;
  background-color: #fff;
}
.form-item input{
  width: 400px;
  height: 40px;
  line-height: 40px;
  border: 1px solid #ccc;
  padding-left: 14px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin-top: 10px;
}
/* 这是原生的input框，给他透明隐藏，然后定位让文件上传的按钮覆盖它 */
#fileInput {
  width: 120px;
  margin-left: 8px;
  filter: Alpha(opacity=0);
  -moz-opacity: 0;
  opacity: 0;
  position: absolute;
  right: 37px;
  z-index: 2;
}
/* 这是主要的，文件上传按钮的样式 */
.file-btn {
  display:inline-block;
  width: 54px;
  height: 30px;
  background: #fff;
  border: 1px solid #ccc;
  text-align: center !important;
  line-height: 32px;
  color: #333333;
  margin-left: 8px;
}
.ftabs {
  background: #fff;
  width: 99%;
}
</style>

<style>
.com_space_content,.com_date_content{
    width: 460px;
}
.com_date_box{
    display: flex;
    align-items: center;
}
.pro_down_box .com_date_box .el-date-editor.el-input{
    width: 230px;
}
.re_down_form .com_space_content .el-form-item__content,
.re_down_form .com_date_content .el-form-item__content{
    width: 350px!important;
}
.com_space_box{
    display: flex;
    align-items: center;
    width: 350px!important;
}
.re_down_form .com_space_box .el-select{
    width: 120px;
    margin-left: 5px;
}
.p_resource_module .r_dropDownScreen .el-checkbox__label{
  padding-left: 3px;
}
.el-tabs__item.is-active {
  color: #19bd92 !important;
}
.p_resource_module .el-table .com_Selection.cell{
  padding: 0 25px 0 5px;
}
.p_resource_module .el-table .com_Selection.cell .el-checkbox__inner{
    position:relative;
}
.p_resource_module .el-table .com_Selection.cell:before{
    content:"全选";
    position:absolute;
    right:2px;
    top: 1px;
}
.re_table.el-table .cell{
  padding: 0 5px;
}
.p_resource_module .screenInput .el-select .el-input__inner{
  width: 100%;
}
.re_table.el-table .el-table__cell{
  padding: 3px 0;
}
.p_resource_module .screenInput .el-input{
  width: 200px;
}
.scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
}
.p_resource_module .re_down_form .el-select,
.p_resource_module .re_down_form .el-cascader,
.p_resource_module .re_down_form.el-form--inline .el-form-item__content{
  width: 225px;
}
.re_down_form .el-form-item{
  margin-bottom: 3px;
  margin-right: 0;
}
.p_btn_box{
    display: flex;
    justify-content: flex-end;
    padding-right: 10px;
    margin-bottom: 15px;
    margin-top: 5px;
}
.p_tabs_box{
  padding: 0 10px;
}
</style>